/**
 * Constantes para formularios de Academia (Admin).
 * Alineadas con catchFormOptions y academyOptions de la app principal.
 */

export const TECHNIQUE_OPTIONS = [
  { value: 'general', label: 'General' },
  { value: 'big-game', label: 'Big game' },
  { value: 'carpfishing', label: 'Carpfishing' },
  { value: 'casting', label: 'Casting' },
  { value: 'cebo-vivo', label: 'Cebo Vivo' },
  { value: 'chambel', label: 'Chambel' },
  { value: 'corcheo', label: 'Corcheo' },
  { value: 'curricán', label: 'Curricán' },
  { value: 'eging', label: 'Eging' },
  { value: 'feeder', label: 'Feeder' },
  { value: 'finesse-agua-dulce', label: 'Finesse agua dulce' },
  { value: 'pesca-de-fondo', label: 'Pesca de Fondo' },
  { value: 'jigging', label: 'Jigging' },
  { value: 'jig-casting', label: 'Jig Casting' },
  { value: 'micro-jigging', label: 'Micro-jigging' },
  { value: 'pesca-a-mosca', label: 'Pesca a mosca' },
  { value: 'pesca-vertical', label: 'Pesca Vertical' },
  { value: 'popping', label: 'Popping' },
  { value: 'rockfishing', label: 'Rockfishing' },
  { value: 'spinning', label: 'Spinning' },
  { value: 'spinning-ligero', label: 'Spinning ligero' },
  { value: 'spinning-pesado', label: 'Spinning pesado' },
  { value: 'surfcasting', label: 'Surfcasting' },
  { value: 'tip-run', label: 'Tip Run' },
];

export const LOCATION_OPTIONS = [
  { value: 'acantilado', label: 'Acantilado' },
  { value: 'arroyo', label: 'Arroyo' },
  { value: 'catamaran', label: 'Catamarán' },
  { value: 'embarcacion', label: 'Barco' },
  { value: 'embarcadero', label: 'Embarcadero' },
  { value: 'estanque', label: 'Estanque' },
  { value: 'hielo', label: 'Hielo' },
  { value: 'kayak', label: 'Kayak' },
  { value: 'muelle', label: 'Muelle' },
  { value: 'orilla', label: 'Orilla' },
  { value: 'orilla-embalse', label: 'Orilla Embalse' },
  { value: 'orilla-playa', label: 'Orilla Playa' },
  { value: 'orilla-rio', label: 'Orilla río' },
  { value: 'pato', label: 'Pato' },
  { value: 'puerto', label: 'Puerto' },
  { value: 'rocas', label: 'Rocas' },
  { value: 'submarina', label: 'Submarina' },
  { value: 'vadeador', label: 'Vadeador' },
  { value: 'otro', label: 'Otro' },
];

export const WATER_TYPE_OPTIONS = [
  { value: '', label: '—' },
  { value: 'dulce', label: 'Agua dulce' },
  { value: 'salada', label: 'Agua salada' },
  { value: 'ambas', label: 'Ambas' },
];

export const CONTENT_TYPE_OPTIONS = [
  { value: '', label: '—' },
  { value: 'tutorial', label: 'Tutorial' },
  { value: 'vlog', label: 'Vlog / Día de pesca' },
  { value: 'jornadas_pesca', label: 'Jornadas pesca' },
  { value: 'travel', label: 'Viaje' },
  { value: 'unboxing', label: 'Unboxing / Material' },
  { value: 'materiales', label: 'Materiales' },
  { value: 'technique', label: 'Técnica' },
  { value: 'knots_rigs', label: 'Nudos y montajes' },
  { value: 'picadas', label: 'Picadas' },
  { value: 'other', label: 'Otro' },
];

export const LANGUAGE_OPTIONS = [
  { value: '', label: '—' },
  { value: 'es', label: 'Español' },
  { value: 'en', label: 'Inglés' },
  { value: 'pt', label: 'Portugués' },
  { value: 'fr', label: 'Francés' },
  { value: 'it', label: 'Italiano' },
  { value: 'other', label: 'Otro' },
];

export const LEVEL_OPTIONS = [
  { value: '', label: '—' },
  { value: 'beginner', label: 'Principiante' },
  { value: 'intermediate', label: 'Intermedio' },
  { value: 'advanced', label: 'Avanzado' },
];

export const STATUS_MAP: Record<string, { label: string; variant: 'error' | 'success' | 'warning' | 'info' | 'neutral' }> = {
  pending: { label: 'Pendiente', variant: 'warning' },
  approved: { label: 'Aprobado', variant: 'success' },
  rejected: { label: 'Rechazado', variant: 'error' },
};

export function shortDate(date: Date): string {
  return date.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

export const REJECTION_TEMPLATES_ACADEMY = [
  { label: 'Contenido no relacionado con pesca', reason: 'El contenido no está relacionado con la temática de pesca.' },
  { label: 'Calidad insuficiente', reason: 'El contenido no cumple con los estándares mínimos de calidad.' },
  { label: 'Contenido duplicado', reason: 'Ya existe contenido similar en la plataforma.' },
  { label: 'Incumple normas', reason: 'El contenido incumple las normas de la comunidad.' },
];
